let appDom = document.querySelector('.js-blog-filter-block');
if (!appDom) {

    appDom = document.querySelector('.js-illinois-made-block');

}

const categoryFilters = JSON.parse(appDom.dataset.categories);

const regionFilters = JSON.parse(appDom.dataset.regions);

const taxonomyFilters = appDom.dataset.taxonomies ? JSON.parse(appDom.dataset.taxonomies) : [];

const pageSeoData = JSON.parse(appDom.dataset.pageMeta);

const showFilterPopup = appDom.dataset.showFilterPopup;

const showPublishDate = appDom.dataset.showPublishDate;

const showCategory = appDom.dataset.showCategory;

// eslint-disable-next-line
let allTaxonomyTerms = [];
// eslint-disable-next-line
taxonomyFilters.map((type) => {

    allTaxonomyTerms = [...allTaxonomyTerms, ...type.terms];

});

export {
    categoryFilters,
    regionFilters,
    taxonomyFilters,
    allTaxonomyTerms,
    pageSeoData,
    showFilterPopup,
    showPublishDate,
    showCategory,
};
